import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const SiteContext = createContext(null);
const LS_KEY = "aimka_current_site_id_v1";

export function SiteProvider({ children }) {
  const [sites, setSites] = useState([]);
  const [currentId, setCurrentIdState] = useState(() => {
    try { return localStorage.getItem(LS_KEY) || ""; }
    catch { return ""; }
  });
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const r = await api.get("/sites");
      setSites(r.data);
      // Pick a default if no current id or the current id no longer exists
      if (!currentId || !r.data.find((s) => s.id === currentId)) {
        const first = r.data.find((s) => s.active) || r.data[0];
        if (first) {
          setCurrentIdState(first.id);
          try { localStorage.setItem(LS_KEY, first.id); } catch (e) { /* ignore */ }
        }
      }
    } catch (e) { /* interceptor handles */ }
    finally { setLoading(false); }
  }, [currentId]);

  useEffect(() => { load(); }, []);   // eslint-disable-line

  const setCurrentId = (id) => {
    setCurrentIdState(id);
    try { localStorage.setItem(LS_KEY, id); } catch (e) { /* ignore */ }
  };

  const current = sites.find((s) => s.id === currentId) || null;

  return (
    <SiteContext.Provider value={{ sites, currentId, current, setCurrentId, loading, reload: load }}>
      {children}
    </SiteContext.Provider>
  );
}

export const useSite = () => {
  const ctx = useContext(SiteContext);
  if (!ctx) throw new Error("useSite must be used within SiteProvider");
  return ctx;
};
